import React from 'react';
import './HorizontalSlider.scss';
import { SliderProps } from './types';

export const HorizontalSlider = <T,>(props: SliderProps<T>): JSX.Element => {
    const {
        cards,
        children,
        justifyContentValue = 'center',
        noScrollMobile,
    } = props;
    return (
        <div className={`slider ${noScrollMobile ? 'sliderNoScroll' : ''}`}>
            <div
                className="sliderInternal"
                style={{
                    justifyContent: noScrollMobile
                        ? justifyContentValue
                        : undefined,
                }}
            >
                {cards.map((cards, index) => children(cards, index))}
            </div>
        </div>
    );
};
